
import emotion.react.css
import kotlinx.browser.localStorage
import kotlinx.browser.window
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.useState
import tables.ad.AdsTable
import tables.category.CategoryTable
import tables.organization.OrganisationTable
import tables.placementCat.PlacementCatTable
import tables.product.ProductTable
import tables.user.UserTable
import web.cssom.*


external interface WelcomeProps : Props

val token = localStorage.getItem("accessToken")

val Welcome = FC<WelcomeProps> {
    var activeTab by useState(0)

    div {
        css {
            backgroundColor = rgb(142, 178, 170)
            alignItems = AlignItems.end
            justifyContent = JustifyContent.end
            display = Display.flex
        }
        button {
            css {
                margin = 5.px
                alignItems = AlignItems.end
                marginBottom = 5.px
                fontSize = 14.px
            }
            +"Выход"
            onClick = {
                localStorage.setItem("accessToken", "")
                window.location.reload()
            }
        }
    }


    div {
        css {
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
            display = Display.flex
            width = 100.pct
            flexDirection = FlexDirection.column

        }
        div {
            css {
                display = Display.flex
                flexDirection = FlexDirection.row
                margin = 10.px
                backgroundColor = rgb(142, 178, 170)
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 0) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 0 }
                +"Категории"
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 1) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 1 }
                +"Продукты"
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 2) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 2 }
                +"Организации"
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 3) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 3 }
                +"Пользователи"
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 4) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 4 }
                +"Реклама"
            }
            div {
                css {
                    cursor = Cursor.pointer
                    margin = 20.px
                    backgroundColor = if (activeTab == 5) Color("#5f5") else NamedColor.transparent
                }
                onClick = { activeTab = 5 }
                +"Размещения"
            }
        }

        when (activeTab) {
            0 -> CategoryTable{}
            1 -> ProductTable{}
            2 -> OrganisationTable{}
            3 -> UserTable{}
            4 -> AdsTable{}
            5 -> PlacementCatTable{}
        }
    }
}